import { render, staticRenderFns } from "./NegoceRequest.vue?vue&type=template&id=f8cedc2c"
import script from "./NegoceRequest.vue?vue&type=script&lang=js"
export * from "./NegoceRequest.vue?vue&type=script&lang=js"
import style0 from "./NegoceRequest.vue?vue&type=style&index=0&id=f8cedc2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports